module.exports = __webpack_public_path__ + "img/icon-bianji.23715f5f.svg";